// extracted by mini-css-extract-plugin
export default {"description":"filingStatus_description__OziIv","content":"filingStatus_content__qw3QR"};